import { formatMmSs, useSecondsCountdown } from './secondsCountdown';

type Props = {
  seconds?: number;
  expiresAtSeconds?: number;
  label: string;
  expiredLabel: string;
};

export const ResetCountdown = ({ seconds, expiresAtSeconds, label, expiredLabel }: Props) => {
  const remaining = useSecondsCountdown({ seconds, expiresAtSeconds });

  if (remaining <= 0) {
    return <p className='text-sm text-destructive'>{expiredLabel}</p>;
  }

  return (
    <p className='text-sm text-muted-foreground'>
      {label} <span className='font-medium tabular-nums'>{formatMmSs(remaining)}</span>
    </p>
  );
};
